<template>
  <div class="main">
    <c-panel title="Idiomas" titleIcon="fas fa-language">
      <!-- Item 8: "cadastrar e manter os dados cadastrais dos idiomas". -->
      <catalogo-crud tipo="idioma" rotuloNovo="NOVO IDIOMA" nomeSingular="idioma"
                     placeholderBusca="Pesquisar por nome ou sigla"
                     :campos="campos" :colunas="colunas" dialogLargura="480px"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'nome', label: 'Nome', obrigatorio: true, span: 16, max: 80 },
      { chave: 'sigla', label: 'Sigla (pt-BR, en, es)', span: 8, max: 10 }
    ],
    colunas: [
      { chave: 'nome', label: 'Nome' },
      { chave: 'sigla', label: 'Sigla', largura: '120px' }
    ]
  })
}
</script>
